import React from "react";
import { Link } from "react-router-dom";
import { AvianLogo } from "./AvianLogo";
import { Instagram, Twitter, Facebook, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0a1f4d] text-white mt-16">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="bg-white inline-block px-4 py-2.5 rounded-2xl">
            <AvianLogo size={26} />
          </div>
          <p className="text-sm text-white/70 mt-5 max-w-xs leading-relaxed">
            Peer-to-peer car rentals across South Africa. Drive trusted, inspected and insured cars from local hosts.
          </p>
          <div className="flex items-center gap-4 mt-6 text-white/70">
            <a href="#" aria-label="Instagram" className="hover:text-white transition-colors"><Instagram size={18} /></a>
            <a href="#" aria-label="Twitter" className="hover:text-white transition-colors"><Twitter size={18} /></a>
            <a href="#" aria-label="Facebook" className="hover:text-white transition-colors"><Facebook size={18} /></a>
          </div>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs tracking-[0.18em] uppercase text-white/50 font-bold mb-4">Drive</p>
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/vehicles" className="hover:text-[#1d7ffd]">Browse cars</Link></li>
            <li><Link to="/vehicles?city=Cape%20Town" className="hover:text-[#1d7ffd]">Cape Town</Link></li>
            <li><Link to="/vehicles?city=Johannesburg" className="hover:text-[#1d7ffd]">Johannesburg</Link></li>
            <li><Link to="/vehicles?city=Durban" className="hover:text-[#1d7ffd]">Durban</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs tracking-[0.18em] uppercase text-white/50 font-bold mb-4">Host</p>
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/host" className="hover:text-[#1d7ffd]">List your car</Link></li>
            <li><Link to="/host" className="hover:text-[#1d7ffd]">Fleet partners</Link></li>
            <li><Link to="/host" className="hover:text-[#1d7ffd]">Chauffeur partners</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs tracking-[0.18em] uppercase text-white/50 font-bold mb-4">Trust</p>
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/trust" className="hover:text-[#1d7ffd]">Insurance</Link></li>
            <li><Link to="/trust" className="hover:text-[#1d7ffd]">Inspection</Link></li>
            <li><Link to="/trust" className="hover:text-[#1d7ffd]">Roadside</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs tracking-[0.18em] uppercase text-white/50 font-bold mb-4">Company</p>
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/how-it-works" className="hover:text-[#1d7ffd]">How it works</Link></li>
            <li><a href="mailto:hello@tadada.co.za" className="hover:text-[#7eb6ff]">Contact</a></li>
            <li><Link to="/privacy" className="hover:text-[#1d7ffd]" data-testid="footer-privacy">Privacy policy</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div className="flex items-center gap-2">
            <MapPin size={14} /> <span>Made in South Africa • Launching across Africa</span>
          </div>
          <div>© {new Date().getFullYear()} tadada. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}
